module.exports = __webpack_public_path__ + "static/media/89.bb630d6d.jpg";